<template>
	<div class="tw-flex-1">
		<template v-if="$isExpertAdmin">
			<b-container fluid class="tw-text-black tw-mt-16">
				<div style="height:max-content" class="tw-flex-1 tw-text-justify tw-overflow-auto">
					<h1 class="tw-text-3xl tw-font-bold tw-text-black">Asignaciones</h1>
					<p>Selecciona una asignacion para editar</p>

					<data-table
						title
						:printable="false"
						:columns="headers"
						:rows="$requests"
						class="m-data-table tw-mt-7 tw-w-full tw-overflow-auto scrollbar-x tw-rounded"
						v-on:row-click="onShowRequestInfo"
					/>
				</div>
			</b-container>
			<modal-request-info @show="onShowRequestInfo = $event" />
		</template>
		<template v-else-if="$isExpertClient">
			<b-container fluid class="tw-text-black tw-mt-16">
				<div style="height:max-content" class="tw-flex-1 tw-text-justify tw-overflow-auto">
					<h1 class="tw-text-3xl tw-font-bold tw-text-black">Asignaciones</h1>
					<p>Selecciona una asignacion para editar</p>
					<assignments-table></assignments-table>
				</div>
			</b-container>
		</template>
	</div>
</template>
<script>
import 'vue2-datepicker/index.css';

import DateTimePicker from 'vue2-datepicker';
import BaseHeader from '@/components/BaseHeader';
import DataTable from "vue2-matable"

import { mapActions, mapGetters } from 'vuex';
import ModalRequestInfo from '../components/Modals/ModalRequestInfo.vue';
import AssignmentsTable from './Assignments/AssignmentsTable.vue';

export default {
	name: 'Assignments',
	components: {
		BaseHeader,
		DateTimePicker,
		DataTable,
		ModalRequestInfo,
		AssignmentsTable,
	},
	data: () => ({
		headers: [
			{
				field: 'client.name',
				label: 'Cliente',
			},
			{
				field: 'uniqueNumber',
				label: 'Numero Unico',
			},
			{
				field: 'description',
				label: 'Descripcion',
			},
			{
				field: 'direction',
				label: 'Direccion',
			},
			{
				field: 'town',
				label: 'Ciudad',
			},
			{
				field: 'province',
				label: 'Provincia',
			},
		],
		onShowRequestInfo: () => { },
	}),
	computed: {
		...mapGetters('auth', [
			'$isExpertAdmin',
			'$isExpertClient'
		]),
		...mapGetters('requests', [
			'$requests'
		]),
	},
	created() {
		this.subscribeRequests()
	},
	methods: {
		...mapActions('requests', ['subscribeRequests']),
	}
};
</script>
<style lang='scss'>
	.mx-datepicker {
		input {
			height: 44px;
			border: none;
		}
	}
	.b-form-file {
		.form-file-text {
			overflow: hidden !important;
			text-overflow: ellipsis !important;
			white-space: nowrap !important;
		}
	}
</style>
